import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Paper, Typography, withStyles, Button as MuiButton, CircularProgress } from '@material-ui/core';
import { withApollo } from 'react-apollo';
import { Button, Row, Col, Form } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { importarConvidadosLoteMutation } from '../../../graphql/Sessao';

const { PUBLIC_URL } = process.env;

const styles = theme => ({
    paper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '700px',
        maxHeight: '90vh',
        overflowY: 'auto',
        padding: theme.spacing(4, 4, 4, 4),
        outline: 'none'
    },
    titulo: {
        marginBottom: '16px'
    },
    instrucoes: {
        marginBottom: '16px',
        '& li': {
            marginBottom: '4px'
        }
    },
    linkModelo: {
        marginBottom: '20px',
        display: 'inline-block'
    },
    fileInputWrapper: {
        marginBottom: '20px'
    },
    botoesAcao: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px',
        marginTop: '20px'
    },
    botaoAcao: {
        marginLeft: '8px'
    },
    secaoResumo: {
        marginTop: '16px'
    },
    blocoResumo: {
        marginBottom: '12px'
    },
    blocoErros: {
        marginBottom: '12px',
        color: '#d32f2f'
    },
    listaDetalhe: {
        marginTop: '4px',
        marginBottom: '0',
        paddingLeft: '20px',
        fontSize: '13px'
    },
    senhaInline: {
        fontFamily: 'monospace',
        backgroundColor: '#f0f0f0',
        padding: '1px 5px',
        borderRadius: '3px'
    }
});

class ImportarConvidadosModal extends Component {

    constructor(props) {
        super(props);
        this.state = this.estadoInicial();
        autoBind(this);
    }

    estadoInicial() {
        return {
            arquivoSelecionado: null,
            processando: false,
            resultado: null,
            mensagemErro: null,
        };
    }

    handleFechar() {
        this.setState(this.estadoInicial());
        this.props.onClose();
    }

    handleSelecionarArquivo(event) {
        const arquivo = event.target.files && event.target.files[0] ? event.target.files[0] : null;
        this.setState({ arquivoSelecionado: arquivo, mensagemErro: null });
    }

    async handleEnviar() {
        const { arquivoSelecionado } = this.state;
        if (!arquivoSelecionado) {
            this.setState({ mensagemErro: 'Selecione um arquivo .xlsx antes de enviar.' });
            return;
        }

        this.setState({ processando: true, mensagemErro: null });

        try {
            const base64Conteudo = await this.lerArquivoComoBase64(arquivoSelecionado);
            const { data } = await this.props.client.mutate({
                mutation: importarConvidadosLoteMutation,
                variables: { base64Conteudo }
            });
            this.setState({
                processando: false,
                resultado: data.importarConvidadosLote
            });
        } catch (e) {
            const debugMessage = (e.graphQLErrors || []).map(err => err.debugMessage || err.message).join('\n');
            this.setState({
                processando: false,
                mensagemErro: debugMessage || e.message || 'Erro ao processar o arquivo.'
            });
        }
    }

    lerArquivoComoBase64(arquivo) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                // result vem como dataURL "data:...;base64,XXXX" — pega só a parte base64
                const dataUrl = reader.result || '';
                const indiceVirgula = dataUrl.indexOf(',');
                resolve(indiceVirgula >= 0 ? dataUrl.substring(indiceVirgula + 1) : dataUrl);
            };
            reader.onerror = () => reject(new Error('Falha ao ler o arquivo selecionado.'));
            reader.readAsDataURL(arquivo);
        });
    }

    handleAdicionarAoFormulario() {
        const { resultado } = this.state;
        if (!resultado) return;

        // Junta as três categorias com usuário resolvido
        const usuariosResolvidos = []
            .concat(resultado.mprsConvidados || [])
            .concat(resultado.externosCriados || [])
            .concat(resultado.externosExistentes || []);

        this.props.onAdicionarConvidados(usuariosResolvidos);
        this.handleFechar();
    }

    renderInstrucoes() {
        const { classes } = this.props;
        return (
            <>
                <Typography variant="body2" component="div" className={classes.instrucoes}>
                    <ol>
                        <li>Baixe o modelo .xlsx e preencha uma linha por convidado.</li>
                        <li>Coluna <b>Tipo</b>: use <code>MPRS</code> (usuário do diretório) ou <code>Externo</code> (cadastro local).</li>
                        <li>Para <b>MPRS</b>, informe Nome <i>ou</i> E-mail — o sistema procura no diretório.</li>
                        <li>Para <b>Externo</b>, Nome e E-mail são obrigatórios; senha é opcional (se vazia, será gerada). Vigência vai até 31/12 do ano corrente.</li>
                        <li>Se um usuário externo já existir com o mesmo e-mail, ele será convidado (sem alterar nome/senha) e a vigência será prorrogada até 31/12 se necessário.</li>
                    </ol>
                </Typography>
                <a
                    href={`${PUBLIC_URL || ''}/templates/modelo-importacao-convidados.xlsx`}
                    download="modelo-importacao-convidados.xlsx"
                    className={classes.linkModelo}
                >
                    Baixar modelo .xlsx
                </a>
                <Form.Group className={classes.fileInputWrapper}>
                    <Form.Label>Arquivo preenchido</Form.Label>
                    <Form.Control
                        type="file"
                        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        onChange={this.handleSelecionarArquivo}
                    />
                </Form.Group>
                {this.state.mensagemErro && (
                    <div style={{ color: '#d32f2f', marginBottom: '10px' }}>{this.state.mensagemErro}</div>
                )}
                <div className={this.props.classes.botoesAcao}>
                    <Button variant="secondary" onClick={this.handleFechar} disabled={this.state.processando}>
                        Cancelar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={this.handleEnviar}
                        disabled={this.state.processando || !this.state.arquivoSelecionado}
                        className={this.props.classes.botaoAcao}
                    >
                        {this.state.processando
                            ? <><CircularProgress size={14} style={{ marginRight: 6 }} /> Processando...</>
                            : 'Processar arquivo'}
                    </Button>
                </div>
            </>
        );
    }

    renderResumo() {
        const { classes } = this.props;
        const { resultado } = this.state;
        if (!resultado) return null;

        const mprsConvidados = resultado.mprsConvidados || [];
        const mprsNaoEncontrados = resultado.mprsNaoEncontrados || [];
        const externosCriados = resultado.externosCriados || [];
        const externosExistentes = resultado.externosExistentes || [];
        const erros = resultado.erros || [];

        const totalResolvidos = mprsConvidados.length + externosCriados.length + externosExistentes.length;

        return (
            <div className={classes.secaoResumo}>
                <div className={classes.blocoResumo}>
                    <Typography variant="body1">
                        <b>{mprsConvidados.length}</b> usuário(s) MPRS convidado(s) para a sessão.
                    </Typography>
                </div>

                <div className={classes.blocoResumo}>
                    <Typography variant="body1">
                        <b>{mprsNaoEncontrados.length}</b> usuário(s) MPRS não encontrado(s):
                    </Typography>
                    {mprsNaoEncontrados.length > 0 && (
                        <ul className={classes.listaDetalhe}>
                            {mprsNaoEncontrados.map((c, i) => (
                                <li key={i}>{[c.nome, c.email].filter(Boolean).join(' — ') || '(linha sem dados)'}</li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className={classes.blocoResumo}>
                    <Typography variant="body1">
                        <b>{externosCriados.length}</b> usuário(s) externo(s) criado(s) e convidado(s) para a sessão.
                    </Typography>
                    {externosCriados.length > 0 && (
                        <ul className={classes.listaDetalhe}>
                            {externosCriados.map((c, i) => (
                                <li key={i}>
                                    {c.nome} — {c.email}
                                    {c.senha ? <> — senha: <span className={classes.senhaInline}>{c.senha}</span></> : null}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <div className={classes.blocoResumo}>
                    <Typography variant="body1">
                        <b>{externosExistentes.length}</b> usuário(s) externo(s) já existente(s), convidado(s) para a sessão:
                    </Typography>
                    {externosExistentes.length > 0 && (
                        <ul className={classes.listaDetalhe}>
                            {externosExistentes.map((c, i) => (
                                <li key={i}>{c.nome} — {c.email}</li>
                            ))}
                        </ul>
                    )}
                </div>

                {erros.length > 0 && (
                    <div className={classes.blocoErros}>
                        <Typography variant="body1" color="error">
                            <b>{erros.length}</b> linha(s) com erro:
                        </Typography>
                        <ul className={classes.listaDetalhe}>
                            {erros.map((m, i) => <li key={i}>{m}</li>)}
                        </ul>
                    </div>
                )}

                <Typography variant="body2" style={{ marginTop: '12px', color: '#666' }}>
                    Ao clicar em "Adicionar à lista", os <b>{totalResolvidos}</b> usuário(s) resolvido(s)
                    serão acrescentados à lista de convidados desta sessão. As alterações só serão persistidas
                    quando você salvar o formulário.
                </Typography>

                <div className={classes.botoesAcao}>
                    <Button variant="secondary" onClick={this.handleFechar}>
                        Fechar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={this.handleAdicionarAoFormulario}
                        disabled={totalResolvidos === 0}
                        className={classes.botaoAcao}
                    >
                        Adicionar à lista
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        const { aberto, classes } = this.props;
        const { resultado } = this.state;

        return (
            <Modal open={aberto} onClose={this.handleFechar}>
                <Paper className={classes.paper}>
                    <Typography variant="h6" className={classes.titulo}>
                        Importar Convidados em Lote
                    </Typography>
                    {resultado === null ? this.renderInstrucoes() : this.renderResumo()}
                </Paper>
            </Modal>
        );
    }
}

ImportarConvidadosModal.propTypes = {
    aberto: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onAdicionarConvidados: PropTypes.func.isRequired,
};

export default withStyles(styles)(withApollo(ImportarConvidadosModal));
